import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    textAlign: 'center'
  },

  codeBlock: {
    backgroundColor: theme.palette.divider,
    margin: '1rem 0',
    borderRadius: '5px',
    padding: '1rem'
  },

  copyButton: {
    color: theme.palette.primary.main,
    display: 'flex',
    justifyContent: 'flex-end',
    widht: '100%',
    cursor: 'pointer',
    '& svg': {
      width: '0.75rem',
      height: '0.75rem'
    }
  }
}))

export default useStyles
